import English from '../lang/en-US.json';
import French from '../lang/fr-FR.json';
import Spanish from '../lang/es-ES.json';
// import Portuguese from '../lang/pt-BR.json';

export const REFORESTATION_TYPE = 'reforestation';
export const CONSERVATION_TYPE = 'conservation';
export const AGROFORESTRY_TYPE = 'agroforestry';
export const REGENERATION_TYPE = 'regeneration';
export const MANAGEMENT_TYPE = 'management';

export const projectTypes = (translate, type = '') => [
  {
    value: REFORESTATION_TYPE,
    title: 'acc.type-afforestation-reforestation',
    description: 'acc.type-afforestation-reforestation.desc',
    checked: REFORESTATION_TYPE === type,
  },
  {
    value: CONSERVATION_TYPE,
    title: 'acc.type-forest-conservation',
    description: 'acc.type-forest-conservation.desc',
    checked: CONSERVATION_TYPE === type,
  },
  {
    value: AGROFORESTRY_TYPE,
    title: 'acc.type-agroforestry',
    description: 'acc.type-agroforestry.desc',
    checked: AGROFORESTRY_TYPE === type,
  },
  {
    value: REGENERATION_TYPE,
    title: 'acc.type-assisted-natural-regeneration',
    description: 'acc.type-assisted-natural-regeneration.desc',
    checked: REGENERATION_TYPE === type,
  },
  {
    value: MANAGEMENT_TYPE,
    title: 'acc.type-improved-forest-management',
    description: 'acc.type-improved-forest-management.desc',
    checked: MANAGEMENT_TYPE === type,
  },
];

export const ACTIVE_STATUS = 'active';
export const REGISTER_STATUS = 'register';
export const PAUSED_STATUS = 'paused';
export const FAILED_STATUS = 'failed';
export const TERMINATED_STATUS = 'terminated';
export const CLOSED_STATUS = 'closed';

export const NO_PROGRESS = -1;
export const BEGIN_PROGRESS = 0;
export const SETUP_PROGRESS = 1;
export const ASSIGN_PROGRESS = 2;
export const UPLOAD_PROGRESS = 3;
export const SUBMIT_PROGRESS = 4;
export const FINISHED_PROGRESS = 5;

export const CARBON_ACTIVE = 'active';
export const CARBON_REJECTED = 'rejected';
export const CARBON_SUBMITTED = 'submitted';
export const CARBON_NOT_FINALISED = 'not-finalised';
export const CARBON_NOT_STARTED = 'not-started';

export const ALL_REPORT_TYPE = 'all-zone';
export const SUB_REPORT_TYPE = 'sub-zone';
export const AREA_PERCENTAGE_LIMIT = 0.9; // 90%

export const MAP_EVENTS = {
  CREATE: 'draw.create',
  UPDATE: 'draw.update',
  DELETE: 'draw.delete',
  SELECT: 'draw.selectionchange',
  MOVE: 'move',
  ZOOM_END: 'zoomend',
  RIGHT_CLICK: 'contextmenu',
  MOUSE_DOWN: 'mousedown',
  MOUSE_UP: 'mouseup',
  MOUSE_MOVE: 'mousemove',
};

// ____STATUS CODE ___
export const
  DecodeError = 10000;
export const ValidateError = 10001;
export const DuplicateAccountIdOrEmailProjectOperator = 10100;
export const FailedToGetProjectOperator = 10101;
export const FailedToCreateProjectOperator = 10102;
export const FailedToUpdateProjectOperator = 10103;
export const FailedToDeleteProjectOperator = 10104;
export const FailedToCreateProjectOperatorInNear = 10105;
export const FailedToDecodeNearResponse = 10106;
export const FailedToCheckAccesskeyInNear = 10107;
export const IncorrectNearAccountId = 10108;
export const UserHasNotVerified = 10109;

export const FailedToGetFiledAgent = 10200;
export const FailedToGetFiledAgentList = 10201;
export const DuplicateFieldAgent = 10202;
export const FailedToCreateFieldAgent = 10203;
export const FailedToUpdateFieldAgent = 10204;
export const FailedToDeleteFieldAgent = 10205;
export const FailedToDecodeFieldAgentId = 10206;
export const FieldAgentDoesNotMatchWithProjectOperator = 10207;
export const FailedToEncryptPushToken = 10208;
export const FailedToDecryptPushToken = 10209;
export const ValidatorDoesNotAcceptTerms = 10300;
export const DuplicateValidator = 13001;
export const FailedToGetValidator = 13002;
export const FailedToCreateValidator = 13003;
export const FailedToUpdateValidator = 13004;
export const FailedToDeleteValidator = 13005;
export const FailedToDecryptValidatorData = 13006;
export const FailedToDecodeValidatorData = 13007;
export const IncorrectValidatorAccountId = 13008;
export const FailedToGetSampleZone = 10400;
export const FailedToGetSampleZoneList = 10401;
export const FailedToCreateSampleZone = 10402;
export const FailedToUpdateSampleZone = 10403;
export const FailedToDeleteSampleZone = 10404;
export const FailedToDeleteSampleZoneList = 10405;
export const FailedToGetProjectNamesFormIndexer = 10500;
export const AuthorizationTokenRequired = 10600;
export const InvalidAuthorizationToken = 10601;
export const TokenDoNotHavePermission = 10602;
export const FailedCreateJwt = 10603;
export const FailedToVerifyJwt = 10604;
export const FailedToPinInInInfura = 10700;
export const FailedToGetProjectFormNear = 10800;
export const FailedToGetProjectStagesFormNear = 10800;
export const FailedToCreateProjectInIndexer = 10900;
export const FailedToUpdateProjectInIndexer = 10901;
export const FailedToSendEmail = 11000;
export const FailedToSendPushMessage = 11100;

export const SORT = {
  ASC: 'asc',
  DESC: 'desc',
};

export const LOCALES = {
  ENGLISH: {
    value: 'en-US',
    label: 'English',
  },
  FRENCH: {
    value: 'fr-FR',
    label: 'Français',
  },
  SPANISH: {
    value: 'es-ES',
    label: 'Español',
  },
  PORTUGUESE: {
    value: 'pt-BR',
    label: 'Português',
  },
};
export const TreeStates = {
  alive: 'alive',
  damaged: 'damaged',
  dead: 'dead',
  tagLost: 'taglost',
  inaccessible: 'inaccessible',
};
export const MESSAGES = {
  [LOCALES.ENGLISH.value]: English,
  [LOCALES.FRENCH.value]: French,
  [LOCALES.SPANISH.value]: Spanish,
  // [LOCALES.PORTUGUESE.value]: Portuguese,
};

export const MAX_FILE_SIZE = 10240; // 10MB
